import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import { Avatar } from "../../components/Avatar";
import { Text } from "../../components/Text";
import styles from "./sk-Signature.module.css";
const avatarSize = {
    small: 24,
    medium: 48,
    large: 64,
};
const isString = (value) => typeof value === "string";
export const Signature = ({ avatar, className, fallbackIcon, hasError, onBackground = "light", size = "medium", secondaryLabel = null, label, ...restProps }) => {
    const mainClassNames = clsx(className, styles.main, {
        [styles[`main--${onBackground}`]]: !!onBackground,
    });
    const labelComponent = isString(label) ? _jsx(Text, { variant: "body1", children: label }) : label;
    const secondaryLabelComponent = isString(secondaryLabel) ? (_jsx(Text, { variant: "body2", children: secondaryLabel })) : (secondaryLabel);
    return (_jsxs("div", { className: mainClassNames, ...restProps, children: [_jsx(Avatar, { className: styles.avatar, hasError: hasError, size: avatarSize[size], fallbackIcon: fallbackIcon, children: avatar }), _jsxs("div", { className: styles.author, children: [labelComponent, secondaryLabelComponent] })] }));
};
Signature.displayName = "Signature";
//# sourceMappingURL=Signature.js.map